module.exports = __webpack_public_path__ + "img/gear-B_82x82.dfdd7bd9.png";